import React, { useState } from 'react'
import {
    LayoutGrid,
    Calendar,
} from 'lucide-react'

export interface TabsProps {
    activeTab: 'rooms' | 'calendar';
    onTabChange: (tab: 'rooms' | 'calendar') => void;
}

export function Tabs({ activeTab, onTabChange }: TabsProps) {
    return (
        <div className="px-6 pb-6 items-center size-full">
            <div className="bg-white rounded-lg p-1.5 flex w-full max-w-[400px] mx-auto">
                <div
                    onClick={() => onTabChange('rooms')}
                    className={`flex items-center justify-center space-x-2 px-4 py-2 rounded cursor-pointer text-center flex-1 ${activeTab === 'rooms' ? 'bg-black text-white' : ''}`}
                >
                    <LayoutGrid size={16} />
                    <span>Rooms</span>
                </div>

                <div
                    onClick={() => onTabChange('calendar')}
                    className={`flex items-center justify-center space-x-2 px-4 py-2 rounded cursor-pointer text-center flex-1 ${activeTab === 'calendar' ? 'bg-black text-white' : ''}`}
                >
                    <Calendar size={16} />
                    <span>Calendar</span>
                </div>
            </div>
        </div>
    )
}
